import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Link, useNavigate } from 'react-router-dom';
import ErrorPopup from '../components/ErrorPopup';
import Blob from '../assets/blob-hero.svg';


function Login() {

    document.title = "Login | Lehumo";

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    //Error Popup
    const [errorPopup, setErrorPopup] = useState(false);
    const [errorMessage, setErrorMessage] = useState();

    //User navigate to redirect to profile page
    const navigate = useNavigate();


    const handleSubmit = (event) => {

        event.preventDefault();

        // Send login request to the server
        fetch('http://localhost:5000/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email, password })
        })
            .then((response) => response.json())
            .then((data) => {
                //Check if login was a success then redirect
                //console.log(data);

                const status = Object.keys(data)[0];

                //console.log(status);

                if (status === 'success') {
                    navigate(`/Overview`)
                } else {
                    setErrorMessage('Incorrect login details');
                    setErrorPopup(true);
                }

            })
            .catch((error) => {
                console.error('Error:', error);
            });

    }

    return (
        <>
            <Container>
                <ErrorPopup trigger={errorPopup} setTrigger={setErrorPopup}>
                    <h3><span>☠️</span><br></br>{errorMessage}</h3>
                    <p>Please try again</p>
                    <center>
                        <button onClick={() => setErrorPopup(false)}>Close</button>
                    </center>
                </ErrorPopup>
                <FormContainer>
                    <center>

                        <form onSubmit={handleSubmit}>
                            <h3>Sign in with your Lehumo Account</h3>
                            <input type="email" name="email" placeholder="Email address" required value={email} onChange={(event) => setEmail(event.target.value)} />
                            <input type="password" name="password" placeholder="Password" value={password} onChange={(event) => setPassword(event.target.value)} /><br />
                            <p><Link to="TermsOfUse">By clicking sign in you accept the terms & conditions</Link></p>
                            <button type="submit" name="submit">Sign in</button>
                        </form>

                        <Link to="/ForgotPassword"><p>Forgot Password?</p></Link>


                        <p>Sign in with your Google account</p>

                        <ExternalAccount>
                            <button className="google-btn"><i className="fa-brands fa-google"></i> Login with Google</button>
                        </ExternalAccount>


                        {/*<div id='signInDiv'></div>*/}

                        <Link to="/Signup"><p>Don't have an account?</p></Link><br />
                    </center>
                </FormContainer>
            </Container>
        </>
    )
}

export default Login

const Container = styled.div`
    background-image: linear-gradient(rgba(255, 246, 246, 0.2),rgba(255, 246, 246, 0.2)),url(${Blob});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: auto;
    display: flex;
    justify-content: center;
    align-item: center;

    
    @media (max-width: 900px) {
        background: var(--background);

    }
`

const FormContainer = styled.div`
    background: var(--background);
    width: 70%;
    height: auto;
    margin: 100px  auto;
    border-radius: 10px;
    justify-content: center;
    align-item: center;
    font-family: 'Poppins', sans-serif;
    box-shadow: rgba(99, 99, 99, 0.5) 0px 2px 8px 0px;
    
    p {
        margin-top: 30px;
        margin-bottom: 10px;
        font-size: 13px;
        font-weight: bold;
    }

    form {
        padding: 20px auto;

        p {
            font-size: 12px;
            margin: 10px auto;
            text-transform: uppercase;
        }
    }

    
    input {
        border: 2px solid var(--primary);
        background: #fff;
        border-radius: 4px;
        width: 300px;
        height: 50px;
        margin-bottom: 10px;
        padding-left: 10px;
        padding-right: 10px;
        outline: none;
        justify-content: space-between;
        margin-left: 2.5px;

        @media (max-width: 900px) {
            width: 300px;
            margin-left: 0;
        }
    }

    button {
        width: 600px;
        height: 50px;
        border-radius: 4px;
        background-color: var(--primary);
        border: 2px solid var(--primary);
        color: #fff;
        text-transform: uppercase;
        margin-top: 5px;
        font-weight: 600;
        font-size: 14px;

        :hover {
            background-color: transparent;
            border-radius: 30px;
            border: 2px solid var(--primary);
            color: var(--primary);
            transition: 0.2s ease-in-out;
        }

        @media (max-width: 900px) {
            width: 300px;
        }
    }


    h3 {
        padding-top: 40px;
        margin-bottom: 20px;
        font-size: 18px;
        font-weight: bold;
        text-align: center;

        @media (max-width: 900px) {
            text-align: center;
            margin-left: 0px;
        }
    }

    @media (max-width: 900px) {
        background: transparent;
        width: 80%;
        margin: 50px auto;
        box-shadow: none;
    }

`

const ExternalAccount = styled.div`

.google-btn {
    background-color: transparent;
    border: 2px solid #000;
    color: #000;
    margin-top: 10px;
    width: 250px;
    text-transform: none;

    :hover {
        background-color: #efefef;
    }
}



`